import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

function Retraining() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="header__custom">
            <h4>Farmatsevtlarni qayta tayyorlash bo'limi boshlig'i</h4>
            <div className="card__custom">
              <div className="box__custom">
                <img src="/img/ulugbekusmanov.jpg" alt />
              </div>
              <div className="box-1__custom">
                <p>Usmanov Ulugbek Khusanovich </p>
                <span> farmatsevtika fanlari doktori </span>
                <br />
                <br />
                <hr />
                <div className="wer__custom">
                  <div className="malinki__custom">
                    <p>E-pochta</p>
                    <span>FMOF@pharmi.uz </span>
                  </div>
                  <div className="malinki1__custom">
                    <p>Telefon nomer</p>
                    <span>+998 90 186-43-53</span>
                  </div>
                </div>
                <div className="wer__custom"></div>
              </div>
            </div>
          </div>
          <div className="card1__custom">
            <p>
              O‘zbekiston SSR Ministrlar Sovetining 1967-yil 6-maydagi 211-sonli
              qaroriga binoan 1969-yil mart oyidan boshlab, Toshkent
              Farmatsevtika instituti qoshida provizorlar malakasini oshirish
              fakulteti (PMOF) tashkil etildi.
              <br />
              <br />
              PMOF ning birinchi tashkilotchisi va birinchi dekani farmatsevtika
              fanlari nomzodi, dotsent T.M.Abralov (1967-1971 yy.) bo‘lganlar.
              Undan keyingi yillarda fakultetda dotsent N.M.Axmedxodjayeva
              (1972-1984 yy.), professor E.R.Toshmuhamedov (1985-1986 yy.),
              dotsent O.V.Bondarenko (1987-1995 yy.), dotsent R.Z.Ziyayev
              (1995-2004 yy.), professor M.M.Miralimov (2004-2011 yy.)
              fakultetga rahbarlik qildilar. 2011-2018 yillarda farmatsevtika
              fanlari doktori, professor X.S.Zaynutdinov fakultet dekani
              lavozimida ishladi. 2018-yil may oyidan hozirgi vaqtgacha fakultet
              dekani lavozimida f.f.n. dotsent U.J. Akromov ishlab kelmoqda.
              <br />
              <br />
              PMOF tinglovchilariga yuqori malakali professor-o‘qituvchilar dars
              berganlar. Jumladan, Farmatsiya ishini tashkil qilish fanidan
              professor E.R.Toshmuhamedov, dotsentlar: T.M.Abralov, V.A.Zaxarov,
              R.Z.Ziyayev, M.T.Radjabov, O.V.Bondarenko, O.X. Xonxodjaev,
              M.Ya.Stepanova, A.A.Karakozova, texnologiyadan professor
              Z.M.Umanskiy, dotsentlar T.K.Kasimova, E.A.Yudovich, A.Sh.Xamzina,
              Z.N.Nazirov; farmatsevtik kimyodan dotsentlar Yo.Q.Qodirov,
              A.Yu.Ibodov, E.A.Puchinyan, L.A.Xabibullayeva, N.F.Drebensova,
              N.M.Axmadxodjaeva; farmakologiyadan professor M.N.Maxsumov,
              dotsent B.X.Xodjayev; farmakognoziyadan professorlar
              R.L.Xazanovich, T.P.Pulatova, dotsentlar A.YA.Ibragimov, N.
              Alimxodjaeva, K.K. Yunusova, I.A.Xarlamov; toksikologik kimyodan
              professor L.T.Ikromov, dotsentlar B.O.Olimxonov, A.Yu.Toshpulatov,
              T.M.Mirxaitov va boshqalar dars berganlar.
              <br />
              <br />
              Ulardan keyingi davrda fakultetda tinglovchilarga professorlar
              M.M.Miralimov, X.M.Yunusova, X.U.Aliyev va O.O.Abidov, dotsentlar
              A.M.Komilov, M.M.Malikov, A.Q.Ganiyev, M.X.Nurmuxamedova,
              G.S.Yusupova, X.K.Abdullayeva, O.M.Ernazarov, X.Q.Olimov, katta
              o‘qituvchilar Sh.Sh.Shamsiev, Z.X.Zufarova va boshqalar ta’lim
              berganlar.
              <br />
              <br />
              Hozirgi kunda fakultetda professorlar X.S.Zaynutdinov,
              M.A.Tojiyev, Z.Salixodjayev, dotsentlar A.M.Tuxtayeva,
              R.T.Tullyaganov, U.J.Akramov, G.M.Ismoilova, N.A.Abduraxmanova,
              X.K.Bekchanov, U.X.Usmanov hamda katta o‘qituvchilar M.Z.Islamova,
              va Sh.T.Salyamova, faoliyat ko‘rsatib kelishmoqda. Fakultet
              faoliyat ko‘rsata boshlaganida to‘rt mutahassislik, ya’ni provizor
              – tashkilotchi, provizor – texnolog, provizor – analitik va ximik
              – ekspert mutahassisliklari bo‘yicha malaka oshirish sikllari
              tashkil etilgan.
              <br />
              <br />
              1994-yilda qo‘shimcha ravishda «Gomeopatiya dori vositalari
              texnologiyasi va sifati» sikli (yo‘nalishi) tashkil etildi.
              <br />
              O‘zbekiston Respublikasi Sog‘liqni saqlash vazirligining 1995-yil
              23-oktyabrdagi 501-sonli buyrug‘i provizorlarning malakasini
              oshirishda katta burilish yasab, unga muvofiq PMOF da 3 ta sikl
              (yo‘nalishi) tashkil etilgan:
              <br />
              <br />
              “Dorixona muassasalari iqtisodiyoti va farmatsiyadagi dolzarb
              muammolar”
              <br />
              <br />
              “Dori tayyorlash texnologiyasi”
              <br />
              <br />
              “Dori sifatini nazorat qilish”
              <br />
              <br />
              O‘qish muddati barcha sikl (yo‘nalishi) larda bir oy qilib
              belgilangan.
              <br />
              <br />
              O‘zbekiston Respublikasi Sog‘liqni saqlash vazirligining 1997-yil
              24-iyundagi 302-sonli “Oliy va o‘rta maxsus o‘quv muassasalari
              o‘qituvchilari malakasini oshirishni yanada takomillashtirish
              haqida” gi buyrug‘iga binoan institut malaka oshirish fakultetida
              2000–2001 o‘quv yili tibbiyot bilim yurti farmatsevtika bo‘limi
              o‘qituvchilari malakasini oshirish sikli (yo‘nalishi) tashkil
              etilgan. O‘zR SSV 2001-yil 5-sentyabrdagi 400-sonli
              «Davolash-profilaktika muassasalari ishini yaxshilash to‘g‘risida»
              gi buyrug‘ini bajarish maqsadida 2001-yil 27-sentyabrda
              institutning 128-sonli «Davolash-profilaktika muassasalari
              dorixonalari xodimlarining malakasini oshirish to‘g‘risida» gi
              buyrug‘i chiqdi. Shu buyruq asosida PMOF da maxsus «Shifoxona
              dorixonasi ishini tashkil qilish» sikli (yo‘nalishi) tashkil
              qilindi.
              <br />
              <br />
              O‘zbekiston Respublikasi Sog‘liqni saqlash vazirligining 2001-yil
              19-noyabrdagi 06/283 sonli xatiga binoan institut provizorlar
              malakasini oshirish fakultetida sud-tibbiyot ekspert kimyogarlari
              uchun 2001-2002 o‘quv yilidan boshlab “Spetsializatsiya” sikli
              (yo‘nalishi) tashkil etildi. Malaka oshirish yo‘nalishlari
              dasturlari 144 soatlik (4 o‘quv xaftasi) hajmida qilib qayta
              ishlandi. 2006-2007 o‘quv yilida FMOF da «O‘zfarmsanoat» kontserni
              farmatsevtika korxonalari mutaxassislarining malakasini oshirish
              sikli (yo‘nalishi) tashkil qilindi. Shu o‘quv yilidan boshlab
              muntazam ravishda chet ellik mutaxassislarni jalb etgan holda Good
              manufacturing practice (GMP), Good pharmacy practice (GPP), Good
              storage practice (GSP) va Good laboratory practice (GLP)
              standartlari bo‘yicha sikl (yo‘nalish) tashkil qilinib kelinadi.
              <br />
              <br />
              O‘zbekiston Respublikasi Adliya vazirligidan 2010-yil 29-iyunda
              2118-son bilan ro‘yxatdan o‘tgan, Sog‘liqni saqlash vazirligining
              2010-yil 18-iyundagi 191-sonli buyrug‘i bilan tasdiqlangan
              “Davolash-profilaktika muassasalarida dori vositalarini tayinlash
              hamda bemorning dori vositalarini qabul qilish, saqlash va
              qo‘llash tartibi, shuningdek dorixona muassasalari tomonidan
              aholiga dori vositalarini retsept asosida berish to‘g‘risida” gi
              Nizom asosida 2010-yil fakultetda 42 soatlik “Dorixona
              muassasalaridan aholiga dori vositalarini retsept asosida berish
              tartib qoidalari” yo‘nalishi tashkil etildi va viloyat sog‘liqni
              saqlash boshqarmalarida seminarlar o‘tkazildi.
              <br />
              <br />
              Shuni ta’kidlash lozimki, amaliy farmatsiya xodimlariga yaqindan
              yordam berish va fakultet ishini oqilona tashkillashtirish
              maqsadida 1996-yildan boshlab viloyat “Dori–darmon” AK viloyat
              bazalari, institut hududiy bazalari va viloyat markazlarida,
              ko‘chma (sayyor) sikllar tashkil etib kelinmoqda. Ko‘chma (sayyor)
              sikllarda mashg‘ulotlar qat’iy reja asosida olib borilmoqda. Bozor
              munosabatlari sharoitida mutaxassislarning malakasini oshirish,
              kasb mahoratini takomillashtirish, dorixona muassasalari ishini
              yaxshilash – aholiga sifatli mahsulot etkazib berishda asosiy
              sifat kafolati bo‘lib kelmoqda.Toshkent farmatsevtika instituti
              provizorlarni malaka oshirish fakultetida xorijiy mamlakatlarda
              provizorlar malakasini oshirish fakulteti tajribalaridan kelib
              chiqqan holda hamda iqtisodiy va ijtimoiy muammolarni echish
              maqsadida 1996 yildan boshlab, har o‘quv yilida 5 tadan ko‘chma
              sikllar tashkil etib kelingan.
              <br />
              <br />
              O‘zbekiston Respublikasi Sog‘liqni saqlash vazirligining 2005-yil
              18-maydagi 226-sonli “Farmatsevt kadrlar malakasini oshirish
              ishlarini takomillashtirish to‘g‘risida”gi buyrug‘i bilan
              farmatsevt kadrlarning diplomdan keyingi malakasini oshirish
              bo‘yicha muvaqqat nizom, undagi lavozim nomenklaturalari bilan
              tasdiqlandi.
              <br />
              <br />
                   Hozirgi kunda FMOF da quyidagi yo‘nalishlar mavjud:
              <br />
              <br />
              – “Dorixona muassasalari iqtisodiyoti va farmatsiyadagi dolzarb
              muammolar”;
              <br />
              <br />
              – “Farmatsevtika amaliyotining dolzarb mavzulari”;
              <br />
              <br />
              – “Dori turlari texnologiyasi”;
              <br />
              <br />
              – “Dori vositalarini sifatini nazorat qilish”;
              <br />
              <br />
              – “Steril dori tayyorlash texnologiyasi”;
              <br />
              <br />
              – “Dorivor o‘simliklardan farmatsevtika amaliyotida
              foydalanishning dolzarb muammolari”;
              <br />
              <br />
              – “Sud kimyogar – ekspertlarining ixtisoslashuvi”;
              <br />
              <br />
              – “Tibbiyot kollejlari farmatsiya bo‘limi pedagoglarining
              malakasini oshirish”;
              <br />
              <br />
              – “Dori vositalarining sanoat texnologiyasi”.
              <br />
              <br />
              “Dori vositalarining sanoat texnologiyasi” yo‘nalishi 2015-2016
              o‘quv yilida tashkil etilib, ushbu yo‘nalish bo‘yicha birinchi
              (ilk) malaka oshirish sikli 2016-yilning fevral oyida bo‘lib
              o‘tgan. Bundan tashqari fakultetda “Davolash – profilaktika
              muassasalari va dorixonalarda fitobarlar faoliyatini tashkil
              etish” va “Dori vositalari va tibbiy buyumlar ulgurji savdosi”
              yo‘nalishlarini tashkil etish rejalashtirilgan. O‘quv jarayonida
              kompyuter dasturini qo‘llashga katta e’tibor beriladi. Shu
              maqsadda o‘quv qo‘llanmalari va elektron darsliklar yaratilgan.
              <br />
              <br />
              Amaliyotga masofaviy ta’lim usuli tatbiq qilinmoqda. Buning uchun
              «Internet» da www.farmaseft.uz sayti ochilib, saytga barcha
              yo‘nalishlar bo‘yicha elektron axborot ta’lim resurslari
              joylashtirilgan, ma’ruzalar multimediyalarni qo‘llab malaka
              oshirish yo‘nalishlari bo‘yicha masofadan o‘qitish yo‘lga
              qo‘yilgan. Tizim turli o‘quv (ta’lim) resurslaridan foydalanish va
              o‘quv materialini o‘zlashtirish darajasiga qarab adaptiv
              o‘qitishni tashkil qilish imkonini beradi. O‘zR OO‘MTV tomonidan
              o‘tkazilgan “Pedagog kadrlar malakasini oshirish va qayta
              tayyorlash jarayonida pedagogik va AKT ni qo‘llash muammolari”
              ilmiy amaliy konferensiyada www.farmaseft.uz – masofaviy ta’lim
              tizimi asosida tinglovchilarga saboq berish uslubining taqdimoti
              o‘tkazilgan bo‘lsa, 2008-yil 8-fevralda O‘zR OO‘MTV tomonidan
              o‘tkazilgan amaliy uslubiy seminarda ushbu uslubni amaliyotga
              joriy etish bo‘yicha tavsiyalar berildi.
              <br />
              <br />
              www.farmaseft.uz saytida «Farmatsevtika amaliyoti dolzarb
              mavzulari» va «Steril dorilar tayyorlash texnologiyasi»
              yo‘nalishlari bo‘yicha farmatsevtlar malakasini oshirish sikllari
              yo‘lga qo‘yilib, o‘qitiladigan fanlar bo‘yicha ma’ruza matnlari,
              test savollari, amaliy mashg‘ulotlar uchun uslubiy qo‘llanmalar
              joylashtirilgan.
              <br />
              <br />
              Darslar Toshkent shahrida muntazam ko‘rinishda va ko‘chma sikl
              shaklida viloyat «Dori-darmon» aksiyadorlik Kompaniyasi bazalarida
              o‘tkazildi.
              <br />
              <br />
              Xozirgi kunda www.farmaseft.uz sayti faoliyatiga kushimchalar
              kiritila boshlandi. Xususan, sayt tarkibiga «Elektron dekanat»
              (E-dekanat) funksiyasini ishga tushirish jarayoni amalga
              oshirilmoqda. E-Dekanat funksiyasi quyidagi afzalliklarga ega:
              talabgorlar malakani oshirish sikllariga yozilish uchun fakultet
              dekanatiga shaxsan kelib hujjatlarni taqdim etishlari shart emas,
              internet orqali talabnomani yuborish imkoniyati mavjud, o‘qish
              harajatlarini to‘lash uchun shartnomalarni elektron pochta yoki
              faks orqali olishi mumkin, dars rejalari va jadvallari bilan
              internet orqali tanishish mumkin. Bularning hammasi, natijada
              tinglovchilarning mablag‘ va vaqtlarining tejalishiga olib keladi.
              <br />
              <br />
              Fakultetda fmoflib – Intranet elektron kutubxona
              bazasi yaratilgan. Jami elektron manbalar – 62 ta (3,69 Gb),
              shundan, elektron darslik va qo‘llanmalar 52 ta, o‘quv
              adabiyotlarining ma’ruza matnlari – 43 ta, elektron o‘quv-uslubiy
              majmualar – 4 ta, taqdimotlar – 39 ta. Shulardan 2 ta darslik
              “Организация фармацевтического дела”, “Независимый Узбекистан”
              elektron darsliklari o‘zining mazmuni, sifati, salohiyati bilan
              uzluksiz ta’lim tizimi uchun o‘quv adabiyotlarining yangi avlodini
              yaratish konsepsiyasi asosida yaratilgan elektron darsliklarning
              III, IV toifali elektron darsliklar guruhiga kiradi. 43 ta
              elektron darslik va qo‘llanmalar I, II toifali elektron darsliklar
              guruhiga kiradi. Fakultet elektron kutubxona bazasidan institut
              yagona lokal tarmog‘iga ulangan barcha kompyuterlardan foydalanish
              imkoniyati yaratilgan.
              <br />
              <br />
              1969-1994 yillarda PMOF bo‘yicha 8000 ga yaqin
              mutaxassis-provizorlar, shu jumladan 3327 provizor-tashkilotchi,
              2774 provizor-texnolog, 1256 provizor-analitik, 559 sud-tibbiyoti
              byurosi ximik-ekspertlari o‘z malakalarini oshirishgan. Shuni
              ta’kidlash lozimki, ushbu yillarda provizor-tashkilotchi,
              provizor-texnolog, provizor-analitiklar sikliga malaka oshirish
              uchun asosan O‘zbekistondan mutaxassislar kelgan bo‘lsa,
              ximik-ekspert lavozimida ishlovchilar esa sobiq ittifoqning barcha
              respublikalaridan kelishgan. 1996-yildan boshlab PMOF da har yili
              500 ga yaqin mutaxassis-provizorlar malaka oshirish kursini
              o‘tganlar. 1986-1994 yillarda 4000 dan ortiq mutaxassis o‘z
              malakasini oshirgan. 2005-2012 yillarda fakultetda malaka oshirgan
              tinglovchilarning soni 7111 nafarni tashkil etdi. 2012-yildan
              boshlab har yili 1000 nafardan ortiq mutaxassislar o‘z
              malakalarini oshirib kelmoqdalar. 2007-2009 yillarda Internet
              tarmog‘i orqali ta’limning masofaviy shaklida 550 mutaxassis o‘z
              malakasini oshirgan.
              <br />
              <br />
              O‘zbekiston Respublikasi Sog‘liqni saqlash vazirligining 2009-yil
              1-iyundagi 162-sonli “O‘zbekiston Respublikasidagi farmatsevt
              kadrlar malakasini oshirishni takomillashtirish chora-tadbirlari
              to‘g‘risida”gi buyrug‘iga binoan Respublika hududida faoliyat
              ko‘rsatayotgan, mulkchilik turidan qat’iy nazar, barcha farmatsevt
              kadrlar “Bank ma’lumotlari” ni to‘plash borasida ijroni
              ta’minlash, farmatsevtlar malakasini oshirish muntazamligini va
              toifa belgilashni takomillashtirish maqsadida shu yildan boshlab
              fakultetda malaka oshirgan farmatsevt kadrlar to‘g‘risida
              ma’lumotlarni elektron tarzda to‘plab borish yo‘lga qo‘yilgan.
              <br />
              <br />
              Yangi 2018-2019 oquv yilidan boshlab Farmasevtlar malakasini
              oshirish fakulteti tarkibida Farmakognoziya va dori vositalarini
              standartlash kafedrasi, hamda 10 oylik qayta tayyorlash kurslari
              tashkil qilindi. FMOF nomi Farmasevt kadrlar malakasini oshirish
              va qayta tayyorlash fakulteti deb ozgartirildi.
              <br />
              <br />
              Hozirgi kunda fakultetda 8ta umumiy malaka oshirish yonalishlari
              hamda 5ta mavzuli malaka oshirish yonalishlari boyicha malaka
              oshirish kurslari hamda sanoat farmatsiyasi, biotexnologiya va
              metrologiya, standartlashtirish va maxsulot sifati menejmenti
              yonalishi bitiruvshilarini qayta tayyorlas kurslari faoliyat olib
              borilmoqda.
            </p>
          </div>
        </div>
        <div className="mt"></div>
      </div>
      <Footer />
    </div>
  );
}

export default Retraining;
